
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Die meisten Träume sind weit weniger bizarr, als wir annehmen. Wir beschäftigen uns aber mehr mit den seltsamen, weil wir sie als intensiver empfinden. Die schönen sind für die Psyche oft belanglos und deshalb uninteressant.  `}<M mdxType="M">{`Gemäss Studien ist der Anteil von guten und bösen Träumen aber fast ausgeglichen, allerdings sind die guten weit weniger erforscht.`}</M>{` Der Grund: Therapeutisch ergibt es mehr Sinn, auf die problembehafteten Beispiele zu fokussieren, die auf psychischen Stress hinweisen.`}</p>
    <p>{`Forscherinnen der Universität Zürich konnten nachweisen, `}<M mdxType="M">{`dass wir 76 Prozent der Hauptpersonen im Traum aus dem Wach­leben kennen.`}</M>{` Ausserdem verarbeiten wir in der Nacht oft reale Vorkommnisse des Tages, auch wenn wir sie auf den ersten Blick nicht als solche erkennen, weil sie in einem fremden Kontext auftreten. 68 Prozent der im Traum vorkommenden Menschen sowie die Hälfte der Gegenstände sind uns gemäss der Zürcher Studie am Vortag begegnet.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;